export interface ITime {
  hour: string;
  minute: string;
  amPm: string;
}
export interface IReportQuestionAnswer {
  questionMappingId: number;
  sosQuestionSk: number;
  userAnswer: string;
  answerId: number;
  inputType: string;
}

export interface IJsonQuestionAnswer {
  questionId: number;
  userAnswer: string;
  sosQuestionSk: number;
  userAnswerArray?: Array<string>;
  answerId: number;
  inputType: string;
  identifier: string;
}

export interface IAttachments {
  attachments: Array<IReportImage>;
}

export interface IAssembledReport {
  mobileReportId: number;
  reportId: string;
  reportPk: 0;
  title: string;
  dateTimeSubmitted: Date;
  reportVersion: string;
  parsedReport: IReportJSON;
  employeeId: string;
  profileId: number;
  deviceType: string;
  deviceOs: string;
  deviceOsVersion: string;
  apiVersion: string;
  dateTimeTransmitted: Date;
  dateTimeReceived: null;
  attachmentJson: string;
  status: number;
  reportJson: string;
}

export class AssembledReport implements IAssembledReport {
  public reportId: string;
  public employeeId: string;
  public profileId: number;
  public deviceType: string;
  public deviceOs: string;
  public deviceOsVersion: string;
  public apiVersion: string;
  public dateTimeReceived: null;
  public dateTimeTransmitted: Date;
  public reportPk: 0;
  public attachmentJson: string;
  public status: number;
  public reportJson: string;

  constructor(
    public mobileReportId: number,
    public title: string,
    public reportVersion: string,
    public dateTimeSubmitted: Date,
    public parsedReport: IReportJSON
  ) {
    if (!parsedReport) {
      this.parsedReport = {
        eventId: 0,
        categoryId: null,
        employeeNumber: '',
        profileId: 0,
        proxyUser: '',
        flight: null,
        notes: null,
        recommendations: null,
        attachments: null,
        questions: null
      };
    }
  }
}

export interface IReportJSON {
  eventId: number;
  categoryId: number;
  employeeNumber: string;
  profileId: number;
  proxyUser: string;
  flight: NRFlight;
  notes: string;
  recommendations: string;
  attachments: any;
  questions: any;
}

export interface AttJson {
  attachment: string;
}

export interface NRFlight {
  airline: number;
  flightNumber: Number;
  flightDate: Date;
  departureStation: string;
  arrivalStation: string;
  noseNumber: Number;
  fleetType: string;
}

export interface IReportSubmitConfirmation {
  reportId: number;
  title: string;
  dateTimeSubmitted: Date;
  dateTimeTransmitted: Date;
  dateTimeReceived: Date;
}

export interface IReportImage {
  image: string;
  fileName: string;
  description: string;
}

export class ReportSubmissionError extends Error {
  public readonly error: Error;
  public readonly name: string;
  public readonly userMessage?: string;
  public readonly userId?: string;
  public readonly proxyUser?: string;
  public readonly profileId?: number;
  public readonly categoryId?: number;
  public readonly additionalData?: any;


  constructor(message: string, options?: {
    error?: Error;
    userMessage?: string;
    userId?: string;
    proxyUser?: string;
    profileId?: number;
    categoryId?: number;
    additionalData?: any;
  }) {
    super(message);
    this.error = options?.error;
    this.name = 'Report Submission Error';
    this.userMessage = options?.userMessage;
    this.userId = options?.userId;
    this.proxyUser = options?.proxyUser;
    this.profileId = options?.profileId;
    this.categoryId = options?.categoryId;
    this.additionalData = options?.additionalData;

    // Ensure proper prototype chain for instanceof checks
    Object.setPrototypeOf(this, ReportSubmissionError.prototype);
  }

  // Helper method to convert error to a loggable object
  toLogObject(): Record<string, any> {
    return {
      message: this.message,
      error: this.error?.toString(),
      name: this.name,
      userMessage: this.userMessage,
      userId: this.userId,
      proxyUser: this.proxyUser,
      profileId: this.profileId,
      categoryId: this.categoryId,
      additionalData: this.additionalData,
    };
  }
}
